import { Timer } from '@mui/icons-material';
import { GracePeriodManager } from '../modules';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const GracePeriod: RouteType = {
  exact: true,
  icon: Timer,
  path: routePaths.gracePeriod,
  title: 'Failed Payment Settings',
  component: () => <GracePeriodManager />,
  permission: 'canModifyPaymentFailureGracePeriod',
};

export default GracePeriod;
